import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { CitationActivityTypeEnum, CitationStatusEnum, EntitySourceEnum } from '../models/lookups.enum';

@Injectable({
	providedIn: 'root'
})
export class CitationService extends BaseService {

	public activityTypeEnum: CitationActivityTypeEnum = new CitationActivityTypeEnum();
	public citationStatusEnum: CitationStatusEnum = new CitationStatusEnum();
	public entitySourceEnum: EntitySourceEnum = new EntitySourceEnum();

	constructor(private http: HttpClient) { 
		super();
	}

	public searchCitationPayments( searchPlate: string, searchCitation: string, searchKey: string, refDate: string){      
		var reqUri = environment.citationApiUrl + 'CitationPayment/searchcitations?plate=' + this.cleanseUrlParam(searchPlate) + '&citation=' + this.cleanseUrlParam(searchCitation) + 
		'&citationKey=' + this.cleanseUrlParam(searchKey) + '&refDate=' + this.cleanseUrlParam(refDate) + '&appKey=' + this.cleanseUrlParam(environment.appToken);
		return this.http.get<any>(reqUri, super.getHeaders());
	}

	public getCitationPayments(key: string){
		var reqUri = environment.citationApiUrl + 'citationpayment?key=' + this.cleanseUrlParam(key);
		return this.http.get<any>(reqUri, super.getHeaders());
	}

	public getAppealsUrl(){
		var reqUri = environment.citationApiUrl + 'citationappeal/getpayappealsurl?key=' + this.cleanseUrlParam(this.getApplicationGuid()) + '&clientKey=' + this.cleanseUrlParam(this.getClientGuid());
		return this.http.get<any>(reqUri, super.getHeaders());
	}
}
